/* "Barrel" of Http Interceptors */
import {HTTP_INTERCEPTORS} from '@angular/common/http';

import {BelegeInterceptor} from './belege-interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [{provide: HTTP_INTERCEPTORS, useClass: BelegeInterceptor, multi: true}];
